import { computed } from 'vue';
import { useAvailability as useAvailabilityMCL } from '@common-vue/media-card-large';
import { useProductType } from '@composables/useProductType';
import { useLatchkey } from '@modules/latchkey/composables';
import { toTraitId } from '@modules/latchkey/utils';

/**
 * @param {string} id
 */
export default function useAvailability(id) {
  const { isConsolidatedLatchKey } = useProductType();

  if (isConsolidatedLatchKey) {
    const { selectedLatchkey } = useLatchkey();
    const traitId = computed(() => toTraitId(id, selectedLatchkey.value));
    const result = useAvailabilityMCL(traitId);
    return {
      isColorAvailable: computed(() => result.isColorAvailable),
      isSizeAvailable: computed(() => result.isSizeAvailable),
    };
  }

  return useAvailabilityMCL(id);
}
